import { render, staticRenderFns } from "./InvoiceView.vue?vue&type=template&id=27a4e8f8&"
import script from "./InvoiceView.vue?vue&type=script&lang=ts&"
export * from "./InvoiceView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports